//bed
import t08 from "../images/atoms/Bed/T08 - Spadari.jpg";
import t09 from "../images/atoms/Bed/T09 - Manzoni.jpg";
import t10 from "../images/atoms/Bed/T10 - Cordusio.jpg";
import t11 from "../images/atoms/Bed/T11 - Spiga.jpg";
import t12 from "../images/atoms/Bed/T12 - Montenapoleone.jpg";
import t13 from "../images/atoms/Bed/T13 - Durini.jpg";
//frame
//wooden
import darkOak from "../images/atoms/Bed/Frame/Wooden/Dark Oak.jpg";
//headbording finishing
//eco nabuk
import darkBrown08 from "../images/atoms/Bed/Headboard Finishing/Eco Nabuk/Dark Brown 08.jpg";
import darkGrey13 from "../images/atoms/Bed/Headboard Finishing/Eco Nabuk/Dark grey 13.jpg";
import ivory01 from "../images/atoms/Bed/Headboard Finishing/Eco Nabuk/Ivory 01.jpg";
import lightGrey11 from "../images/atoms/Bed/Headboard Finishing/Eco Nabuk/Light grey 11.jpg";
import sand02 from "../images/atoms/Bed/Headboard Finishing/Eco Nabuk/Sand 02.jpg";
//fabric
import darkGrey15_2 from "../images/atoms/Bed/Headboard Finishing/Fabric/Dark Grey 15-2.jpg";
import lightGrey12_1 from "../images/atoms/Bed/Headboard Finishing/Fabric/Light grey 12-1.jpg";
import taupe2_1 from "../images/atoms/Bed/Headboard Finishing/Fabric/Taupe 2-1.jpg";
import white2_1 from "../images/atoms/Bed/Headboard Finishing/Fabric/White 3-1.jpg";
//vintage eco leather
import black107 from "../images/atoms/Bed/Headboard Finishing/Vintage Eco Leather/Black 107.jpg";
import lightGrey1009 from "../images/atoms/Bed/Headboard Finishing/Vintage Eco Leather/LT Grey 1009.jpg";
import darkBrown106 from "../images/atoms/Bed/Headboard Finishing/Vintage Eco Leather/Dark brown 106.jpg";
import white1008 from "../images/atoms/Bed/Headboard Finishing/Vintage Eco Leather/White 1008.jpg";
//embroidery-brown
//bicocca
import bicoccaBlackWhite from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - Black_White.jpg";
import bicoccaBordeauxWhite from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - Bordeaux_White.jpg";
import bicoccaDkChocolateWhite from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - DK Chocolate_White.jpg";
import bicoccaDkGoldWhite from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - DK Gold_White.jpg";
import bicoccaDkGreyWhite from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - DK Grey_White.jpg";
import bicoccaGrGreen7972_7526_7411_7414 from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - GR GREEN - 7972_7526_7411_7414.jpg";
import bicoccaIndBlueWhite from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - Ind.Blue_White.jpg";
import bicoccaLtGrey9901_9946_9509_9355 from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - LT GRAY - 9901_9946_9509_9355.jpg";
import bicoccaPrPink3955_3377_3364_3135 from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - PR PINK - 3955_3377_3364_3135.jpg";
import bicoccaWhiteBlack from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Black.jpg";
import bicoccaWhiteBordeaux from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_bordeaux.jpg";
import bicoccaDarkGrey from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_dark grey.jpg";
import bicoccaWhiteDkChocolate from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_DK Chocolate.jpg";
import bicoccaWhiteDkGold from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_DK Gold.jpg";
import bicoccaWhiteDkGrey from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_DK Grey.jpg";
import bicoccaWhiteGrGreen from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_GR Green.jpg";
import bicoccaWhiteIndBlue from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Ind.Blue.jpg";
import bicoccaWhiteIvory from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Ivory.jpg";
import bicoccaLtGold from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_LT Gold.jpg";
import bicoccaLtGrey from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_LT Grey.jpg";
import bicoccaWhiteNavy from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Navy.jpg";
import bicoccaWhiteOrange from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Orange.jpg";
import bicoccaWhitePeri from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Peri.jpg";
import bicoccaWhitePink from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_PW Pink.jpg";
import bicoccaSand from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Sand.jpg";
import bicoccaWhiteTurquoise from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Turquoise.jpg";
import bicoccaWhiteViolet from "../images/atoms/Embroidery-brown/Bicocca/Bicocca - white_Violet.jpg";
//embroidery-purple
//accademia
import accademiaBordeauxWhite from "../images/atoms/Embroidery-purple/Accademia/Accademia - Bordeaux_White.jpg";
import accademiaDkChocolateWhite from "../images/atoms/Embroidery-purple/Accademia/Accademia - DK Chocolate_White.jpg";
import accademiaDkGreyWhite from "../images/atoms/Embroidery-purple/Accademia/Accademia - DK Grey_White.jpg";
import accademiaOrangeWhite from "../images/atoms/Embroidery-purple/Accademia/Accademia - Orange_White.jpg";
//Meda
import medaDkGreyLtGrey from "../images/atoms/Embroidery-purple/Meda/Meda - DK Grey_LT Grey.jpg";
import medaIndBluePeri from "../images/atoms/Embroidery-purple/Meda/Meda - Ind.Blue_Peri.jpg";
import medaOrangePrPink from "../images/atoms/Embroidery-purple/Meda/Meda - Orange_PR Pink.jpg";
import medaSandWhite from "../images/atoms/Embroidery-purple/Meda/Meda - Sand_White.jpg";
//Necchi
import necchiBordeauxWhiteTurquoise from "../images/atoms/Embroidery-purple/Necchi/Necchi - Bordeaux - White_Turquoise.jpg";
import necchiIndBlueWhiteOrange from "../images/atoms/Embroidery-purple/Necchi/Necchi - Ind.Blue - White_Orange.jpg";
import necchiOrangeWhiteBlue from "../images/atoms/Embroidery-purple/Necchi/Necchi - Orange - White_Blue.jpg";
import necchiTurquoiseWhiteBordeaux from "../images/atoms/Embroidery-purple/Necchi/Necchi - Turquoise - White_Bordeaux.jpg";
//PalazzoReale
import palazzoRealeBordeauxPrPinkWhite from "../images/atoms/Embroidery-purple/Palazzo Reale/Palazzo Reale - Bordeaux - Pr Pink_White.jpg";
import palazzoRealeDkChocolateLtGreyWhite from "../images/atoms/Embroidery-purple/Palazzo Reale/Palazzo Reale - DK Chocolate - LT Grey_White.jpg";
import palazzoRealeDkGreyPeriWhite from "../images/atoms/Embroidery-purple/Palazzo Reale/Palazzo Reale - DK Grey - Peri_White.jpg";
import palazzoRealeVioletGrGreenWhite from "../images/atoms/Embroidery-purple/Palazzo Reale/Palazzo Reale - Violet - GR Green_White.jpg";
//Sempione
import sempioneDkGreyBordeauxGold from "../images/atoms/Embroidery-purple/Sempione/Sempione - DK Grey - Bordeaux_Gold.jpg";
import sempioneGrGreenIndBluePeri from "../images/atoms/Embroidery-purple/Sempione/Sempione - GR Green - Ind.Blue_Peri.jpg";
import sempioneIndBlueOrangeGrGreen from "../images/atoms/Embroidery-purple/Sempione/Sempione - Ind.Blue - Orange_GR Green.jpg";
import sempioneSandBlackWhite from "../images/atoms/Embroidery-purple/Sempione/Sempione - Sand - Black_White.jpg";
//Vela
import velaBlackWhite from "../images/atoms/Embroidery-purple/Vela/Vela - Black_White.jpg";
import velaDkChocolateLtGrey from "../images/atoms/Embroidery-purple/Vela/Vela - Dk Chocolate_LT Grey.jpg";
import velaDkGoldWhite from "../images/atoms/Embroidery-purple/Vela/Vela - Dk Gold_White.jpg";
import velaDkGreyWhite from "../images/atoms/Embroidery-purple/Vela/Vela - Dk Grey_White.jpg";
//Velasca
import velascaBlackOrangeWhite from "../images/atoms/Embroidery-purple/Velasca/Velasca - Black - Orange_White.jpg";
import velascaLtGreyDkGreyWhite from "../images/atoms/Embroidery-purple/Velasca/Velasca - LT Grey - DK Grey_White.jpg";
import velascaOrangeDkChocolateWhite from "../images/atoms/Embroidery-purple/Velasca/Velasca - Orange - DK Chocolate_White.jpg";
import velascaSandBordeauxWhite from "../images/atoms/Embroidery-purple/Velasca/Velasca - Sand - Bordeaux_White.jpg";
//Embroidery-red
//accademia
import accademiaWhite3955_3377_3364 from "../images/atoms/Embroidery-red/Accademia/Accademia - White -  3955_3377_3364.jpg";
import accademiaWhite3884_386_2246 from "../images/atoms/Embroidery-red/Accademia/Accademia - White - 3884_386_2246.jpg";
import accademiaWhite8932_865_8376 from "../images/atoms/Embroidery-red/Accademia/Accademia - White - 8932_865_8376.jpg";
import accademiaWhite9946_9509_9355 from "../images/atoms/Embroidery-red/Accademia/Accademia - White - 9946_9509_9355.jpg";
//palazzo reale
import palazzoRealeWhiteBordeauxPwPink from "../images/atoms/Embroidery-red/Palazzo Reale/Palazzo Reale - White - Bordeaux_PWPink.jpg";
import palazzoRealeWhiteDkChocolateLtGrey from "../images/atoms/Embroidery-red/Palazzo Reale/Palazzo Reale - White - DKChocolate_LTGrey.jpg";
import palazzoRealeWhiteDkGreyPeri from "../images/atoms/Embroidery-red/Palazzo Reale/Palazzo Reale - White - DKGrey_Peri.jpg";
import palazzoRealeWhiteVioletGrGreen from "../images/atoms/Embroidery-red/Palazzo Reale/Palazzo Reale - White - Violet_GrGreen.jpg";
//vela
import velaDkGreyWhite_b from "../images/atoms/Embroidery-red/Vela/Vela - DKGrey_White.jpg";
import velaLtGreyDkChocolate from "../images/atoms/Embroidery-red/Vela/Vela - LT Grey_DKChocolate.jpg";
import velaWhiteDkGold from "../images/atoms/Embroidery-red/Vela/Vela - White_DKGold.jpg";
import velaWhiteDkGrey from "../images/atoms/Embroidery-red/Vela/Vela - White_DKGrey.jpg";
//embroidery yellow
//city life
import cityLifeBordeauxPwPink from "../images/atoms/Embroidery-yellow/City Life/City Life - Bordeaux_PW Pink.jpg";
import cityLifeDkChocolateLTGrey from "../images/atoms/Embroidery-yellow/City Life/City Life - DK Chocolate_LT Grey.jpg";
import cityLifeDKGreyLtGrey from "../images/atoms/Embroidery-yellow/City Life/City Life - DK Grey_LT Grey.jpg";
import cityLifeIndBlueGrGreen from "../images/atoms/Embroidery-yellow/City Life/City Life - Ind.Blue_GR Green.jpg";
//galleria
import galleriaDkChocolateOrange from "../images/atoms/Embroidery-yellow/Galleria/Galleria - DK Chocolate_Orange.jpg"
import galleriaDkGreyPeri from "../images/atoms/Embroidery-yellow/Galleria/Galleria - DK Grey_Peri.jpg"
import galleriaSandWhite from "../images/atoms/Embroidery-yellow/Galleria/Galleria - Sand_White.jpg"
import galleriaTurquoiseDkGold from "../images/atoms/Embroidery-yellow/Galleria/Galleria - Turquoise_DK Gold.jpg"
//meda
import medaDkGreyLtGreye from "../images/atoms/Embroidery-yellow/Meda/Meda - DK Grey_LT Grey.jpg"
import medaIndBluePeri_c from "../images/atoms/Embroidery-yellow/Meda/Meda - Ind.Blue_Peri.jpg"
import medaOrangePwPink from "../images/atoms/Embroidery-yellow/Meda/Meda - Orange_PW Pink.jpg"
import medaWhiteSand from "../images/atoms/Embroidery-yellow/Meda/Meda - White_Sand.jpg"
//environment
import environment429C from "../images/atoms/Environment/ENVIRONMENT - 429 C.jpg";
import environment5025C from "../images/atoms/Environment/ENVIRONMENT - 5025 C.jpg";
import environment644C from "../images/atoms/Environment/ENVIRONMENT - 644 C.jpg";
import environmentCoolGrey1C from "../images/atoms/Environment/ENVIRONMENT - Cool grey 1C.jpg";
import environmentWarmGrey3C from "../images/atoms/Environment/ENVIRONMENT - Warm grey 3C.jpg";
import environmentWhite from "../images/atoms/Environment/ENVIRONMENT- White.jpg";

//fashion green
//darsena
import darsenaIndBlueDkGrey from "../images/atoms/Fashion-green/Darsena/Darsena - Ind.Blue_DK Grey.jpg";
import darsenaOrangeDkGrey from "../images/atoms/Fashion-green/Darsena/Darsena - Orange_DK Grey.jpg";
//necchi
import necchiOrangeIndBlue from "../images/atoms/Fashion-green/Necchi/Necchi - Orange_Ind.Blue.jpg";
import necchiTurquoiseBordeaux from "../images/atoms/Fashion-green/Necchi/Necchi - Turquoise_Bordeaux.jpg";
//orto botanico
import ortoBotanicoDkGreyLtGold from "../images/atoms/Fashion-green/OrtoBotanico/Orto botanico - DK Grey_LT Gold.jpg";
import ortoBotanicoGrGreenIndBlue from "../images/atoms/Fashion-green/OrtoBotanico/Orto botanico - GR Green_Ind.Blue.jpg";
//parco acqua
import parcoAcquaPeriDkGold from "../images/atoms/Fashion-green/ParcoAcqua/Parco dell acqua - Peri_DK Gold.jpg";
import parcoAcquaPwPinkDkGold from "../images/atoms/Fashion-green/ParcoAcqua/Parco dell acqua - PW Pink_DK Gold.jpg";
//roseto
import rosetoOrangeDkGrey from "../images/atoms/Fashion-green/Roseto/Roseto - Orange_DK Grey.jpg";
import rosetoSandDkGrey from "../images/atoms/Fashion-green/Roseto/Roseto - Sand_DK Grey.jpg";
//san babila
import rosetoSanBabila from "../images/atoms/Fashion-green/SanBabila/San Babila.jpg";
//sempione
import rosetoSempione from "../images/atoms/Fashion-green/Sempione/Sempione.jpg";
//jacquard orange
//city life
import cityLifeBordeauxPrPinkBordeaux from "../images/atoms/Jacquard-orange/City Life/City Life - Bordeaux_PR Pink - Bordeaux.jpg";
import cityLifeDkGreyLtGreyDkGrey from "../images/atoms/Jacquard-orange/City Life/City Life - DK Grey_LT Grey - DK Grey.jpg";
import cityLifeIndBlueGrGreenIndBlue from "../images/atoms/Jacquard-orange/City Life/City Life - Ind.Blue_GR Green - Ind.Blue.jpg";
//galleria
import galleriaDkChocolateOrangeDkChocolate from "../images/atoms/Jacquard-orange/Galleria/Galleria - DK Chocolate_Orange - DK Chocolate.jpg";
import galleriaDkGreyPeriDkGrey from "../images/atoms/Jacquard-orange/Galleria/Galleria - DK Grey_Peri - DK Grey.jpg";
import galleriaTurquoiseDkGoldDkGold from "../images/atoms/Jacquard-orange/Galleria/Galleria - Turquoise_DK Gold - DK Gold.jpg";
//meda
import medaDkGreyLtGrey_b from "../images/atoms/Jacquard-orange/Meda/Meda - DK Grey_LT Grey.jpg";
import medaIndBluePeri_b from "../images/atoms/Jacquard-orange/Meda/Meda - Ind.Blue_Peri.jpg";
import medaOrangePrPink_b from "../images/atoms/Jacquard-orange/Meda/Meda - Orange_PR Pink.jpg";
//palestro
import palestroDkGreyBordeaux from "../images/atoms/Jacquard-orange/Palestro/Palestro - DK Grey Bordeaux.jpg";
import palestroLtGreyDkChocolate from "../images/atoms/Jacquard-orange/Palestro/Palestro - LT Grey_DK Chocolate.jpg";
import palestroPeriOrange from "../images/atoms/Jacquard-orange/Palestro/Palestro - Peri_Orange.jpg";
//vela
import velaDkChocolateWhite from "../images/atoms/Jacquard-orange/Vela/Vela - DK Chcolate_White.jpg";
import velaDkGoldWhite_b from "../images/atoms/Jacquard-orange/Vela/Vela - DK Gold_White.jpg";
import velaDkGreyWhite_c from "../images/atoms/Jacquard-orange/Vela/Vela - DK Grey_White.jpg";
//velasca
import velascaBordeauxSand from "../images/atoms/Jacquard-orange/Velasca/Velasca - Bordeaux_Sand.jpg";
import velascaDkChocolateOrange from "../images/atoms/Jacquard-orange/Velasca/Velasca - Dk Chocolate_Orange.jpg";
import velascaDkGreyLtGrey from "../images/atoms/Jacquard-orange/Velasca/Velasca - DK Grey_LT Grey.jpg";
//jacquard blue
//accademia
import accademiaBordeauxPwPink from "../images/atoms/Jacquard-blue/Accademia/Accademia - Bordeaux_PW Pink.jpg";
import accademiaDkChocolateLtGrey from "../images/atoms/Jacquard-blue/Accademia/Accademia - DK Chocolate_LT Grey.jpg";
import accademiaDkGreyLtGrey from "../images/atoms/Jacquard-blue/Accademia/Accademia - DK Grey_LT Grey.jpg";
import accademiaOrangeWhite_b from "../images/atoms/Jacquard-blue/Accademia/Accademia - Orange_White.jpg";
//vela
import velaDkChocolate from "../images/atoms/Jacquard-blue/Vela/Vela - DK Chocolate.jpg";
import velaDkGold from "../images/atoms/Jacquard-blue/Vela/Vela - DK Gold.jpg";
import velaDkGrey from "../images/atoms/Jacquard-blue/Vela/Vela - DK Grey.jpg";
import velaWhite from "../images/atoms/Jacquard-blue/Vela/Vela - White.jpg";
//timeless blue
//fontana
import fontanaBordeaux from "../images/atoms/Timeless-blue/Fontana/Fontana_bordeaux.jpg";
import fontanaDkGold from "../images/atoms/Timeless-blue/Fontana/Fontana_DKGold.jpg";
import fontanaDkGrey from "../images/atoms/Timeless-blue/Fontana/Fontana_DKGrey.jpg";
import fontanaIndBlue from "../images/atoms/Timeless-blue/Fontana/Fontana_Ind.Blue.jpg";
import fontanaTurquoise from "../images/atoms/Timeless-blue/Fontana/Fontana_Turquoise.jpg";
//naviglio
import naviglioBordeaux from "../images/atoms/Timeless-blue/Naviglio/Naviglio_Bordeaux.jpg";
import naviglioDkGold from "../images/atoms/Timeless-blue/Naviglio/Naviglio_DKGold.jpg";
import naviglioDkGrey from "../images/atoms/Timeless-blue/Naviglio/Naviglio_DKGrey.jpg";
import naviglioIndBlue from "../images/atoms/Timeless-blue/Naviglio/Naviglio_Ind.Blue.jpg";
import naviglioTurquoise from "../images/atoms/Timeless-blue/Naviglio/Naviglio_turquoise.jpg";
//piazza
import piazzaBlue from "../images/atoms/Timeless-blue/Piazza/Piazza blue.jpg";
import piazzaBordeaux from "../images/atoms/Timeless-blue/Piazza/Piazza bordeaux.jpg";
import piazzaGold from "../images/atoms/Timeless-blue/Piazza/Piazza gold.jpg";
import piazzaGrey from "../images/atoms/Timeless-blue/Piazza/Piazza grey.jpg";
import piazzaTurquoise from "../images/atoms/Timeless-blue/Piazza/Piazza turquoise.jpg";
//timeless magenta
//sforza
import sforzaBlack from "../images/atoms/Timeless-magenta/Sforza/Black.jpg";
import sforzaBordeaux from "../images/atoms/Timeless-magenta/Sforza/Bordeaux.jpg";
import sforzaDkChocolate from "../images/atoms/Timeless-magenta/Sforza/Dark Chocolate.jpg";
import sforzaDkGold from "../images/atoms/Timeless-magenta/Sforza/Dark Gold.jpg";
import sforzaDkGrey from "../images/atoms/Timeless-magenta/Sforza/Dark Grey.jpg";
import sforzaGrGreen from "../images/atoms/Timeless-magenta/Sforza/Grass Green.jpg";
import sforzaIndBlue from "../images/atoms/Timeless-magenta/Sforza/Indaco Blue.jpg";
import sforzaIvory from "../images/atoms/Timeless-magenta/Sforza/Ivory.jpg";
import sforzaLtGold from "../images/atoms/Timeless-magenta/Sforza/Light Gold.jpg";
import sforzaLtGrey from "../images/atoms/Timeless-magenta/Sforza/Light Grey.jpg";
import sforzaNavy from "../images/atoms/Timeless-magenta/Sforza/Navy.jpg";
import sforzaOrange from "../images/atoms/Timeless-magenta/Sforza/Orange.jpg";
import sforzaPeri from "../images/atoms/Timeless-magenta/Sforza/Peri.jpg";
import sforzaPwPink from "../images/atoms/Timeless-magenta/Sforza/Powder Pink.jpg";
import sforzaSand from "../images/atoms/Timeless-magenta/Sforza/Sand.jpg";
import sforzaTurquoise from "../images/atoms/Timeless-magenta/Sforza/Turquoise.jpg";
import sforzaViolet from "../images/atoms/Timeless-magenta/Sforza/Violet.jpg";
import sforzaWhite from "../images/atoms/Timeless-magenta/Sforza/White.jpg";

const iconsMap = {
  //bed
  t08: t08,
  t09: t09,
  t10: t10,
  t11: t11,
  t12: t12,
  t13: t13,
  darkOak: darkOak,
  darkBrown08: darkBrown08,
  darkGrey13: darkGrey13,
  ivory01: ivory01,
  lightGrey11: lightGrey11,
  sand02: sand02,
  //fabric
  darkGrey15_2: darkGrey15_2,
  lightGrey12_1: lightGrey12_1,
  taupe2_1: taupe2_1,
  white2_1: white2_1,
  //vintage eco leather
  black107: black107,
  lightGrey1009: lightGrey1009,
  darkBrown106: darkBrown106,
  white1008: white1008,
  //embroidery-brown
  //bicocca
  bicoccaBlackWhite: bicoccaBlackWhite,
  bicoccaBordeauxWhite: bicoccaBordeauxWhite,
  bicoccaDkChocolateWhite: bicoccaDkChocolateWhite,
  bicoccaDkGoldWhite: bicoccaDkGoldWhite,
  bicoccaDkGreyWhite: bicoccaDkGreyWhite,
  bicoccaGrGreen7972_7526_7411_7414: bicoccaGrGreen7972_7526_7411_7414,
  bicoccaIndBlueWhite: bicoccaIndBlueWhite,
  bicoccaLtGrey9901_9946_9509_9355: bicoccaLtGrey9901_9946_9509_9355,
  bicoccaPrPink3955_3377_3364_3135: bicoccaPrPink3955_3377_3364_3135,
  bicoccaWhiteBlack: bicoccaWhiteBlack,
  bicoccaWhiteBordeaux: bicoccaWhiteBordeaux,
  bicoccaDarkGrey: bicoccaDarkGrey,
  bicoccaWhiteDkChocolate: bicoccaWhiteDkChocolate,
  bicoccaWhiteDkGold: bicoccaWhiteDkGold,
  bicoccaWhiteDkGrey: bicoccaWhiteDkGrey,
  bicoccaWhiteGrGreen: bicoccaWhiteGrGreen,
  bicoccaWhiteIndBlue: bicoccaWhiteIndBlue,
  bicoccaWhiteIvory: bicoccaWhiteIvory,
  bicoccaLtGold: bicoccaLtGold,
  bicoccaLtGrey: bicoccaLtGrey,
  bicoccaWhiteNavy: bicoccaWhiteNavy,
  bicoccaWhiteOrange: bicoccaWhiteOrange,
  bicoccaWhitePeri: bicoccaWhitePeri,
  bicoccaWhitePink: bicoccaWhitePink,
  bicoccaSand: bicoccaSand,
  bicoccaWhiteTurquoise: bicoccaWhiteTurquoise,
  bicoccaWhiteViolet: bicoccaWhiteViolet,
  //embroidery-purple
  //accademia
  accademiaBordeauxWhite: accademiaBordeauxWhite,
  accademiaDkChocolateWhite: accademiaDkChocolateWhite,
  accademiaDkGreyWhite: accademiaDkGreyWhite,
  accademiaOrangeWhite: accademiaOrangeWhite,
  //Meda
  medaDkGreyLtGrey: medaDkGreyLtGrey,
  medaIndBluePeri: medaIndBluePeri,
  medaOrangePrPink: medaOrangePrPink,
  medaSandWhite: medaSandWhite,
  //Necchi
  necchiBordeauxWhiteTurquoise: necchiBordeauxWhiteTurquoise,
  necchiIndBlueWhiteOrange: necchiIndBlueWhiteOrange,
  necchiOrangeWhiteBlue: necchiOrangeWhiteBlue,
  necchiTurquoiseWhiteBordeaux: necchiTurquoiseWhiteBordeaux,
  //PalazzoReale
  palazzoRealeBordeauxPrPinkWhite: palazzoRealeBordeauxPrPinkWhite,
  palazzoRealeDkChocolateLtGreyWhite: palazzoRealeDkChocolateLtGreyWhite,
  palazzoRealeDkGreyPeriWhite: palazzoRealeDkGreyPeriWhite,
  palazzoRealeVioletGrGreenWhite: palazzoRealeVioletGrGreenWhite,
  //Sempione
  sempioneDkGreyBordeauxGold: sempioneDkGreyBordeauxGold,
  sempioneGrGreenIndBluePeri: sempioneGrGreenIndBluePeri,
  sempioneIndBlueOrangeGrGreen: sempioneIndBlueOrangeGrGreen,
  sempioneSandBlackWhite: sempioneSandBlackWhite,
  //Vela
  velaBlackWhite: velaBlackWhite,
  velaDkChocolateLtGrey: velaDkChocolateLtGrey,
  velaDkGoldWhite: velaDkGoldWhite,
  velaDkGreyWhite: velaDkGreyWhite,
  //Velasca
  velascaBlackOrangeWhite: velascaBlackOrangeWhite,
  velascaLtGreyDkGreyWhite: velascaLtGreyDkGreyWhite,
  velascaOrangeDkChocolateWhite: velascaOrangeDkChocolateWhite,
  velascaSandBordeauxWhite: velascaSandBordeauxWhite,
  //Embroidery-red
  //accademia
  accademiaWhite3955_3377_3364: accademiaWhite3955_3377_3364,
  accademiaWhite3884_386_2246: accademiaWhite3884_386_2246,
  accademiaWhite8932_865_8376: accademiaWhite8932_865_8376,
  accademiaWhite9946_9509_9355:  accademiaWhite9946_9509_9355,
  //palazzo reale
  palazzoRealeWhiteBordeauxPwPink: palazzoRealeWhiteBordeauxPwPink,
  palazzoRealeWhiteDkChocolateLtGrey: palazzoRealeWhiteDkChocolateLtGrey,
  palazzoRealeWhiteDkGreyPeri: palazzoRealeWhiteDkGreyPeri,
  palazzoRealeWhiteVioletGrGreen: palazzoRealeWhiteVioletGrGreen,
  //vela
  velaDkGreyWhite_b: velaDkGreyWhite_b,
  velaLtGreyDkChocolate: velaLtGreyDkChocolate,
  velaWhiteDkGold: velaWhiteDkGold,
  velaWhiteDkGrey: velaWhiteDkGrey,
  //embroidery yellow
  //city life
  cityLifeBordeauxPwPink: cityLifeBordeauxPwPink,
  cityLifeDkChocolateLTGrey: cityLifeDkChocolateLTGrey,
  cityLifeDKGreyLtGrey: cityLifeDKGreyLtGrey,
  cityLifeIndBlueGrGreen: cityLifeIndBlueGrGreen,
  //galleria
  galleriaDkChocolateOrange: galleriaDkChocolateOrange,
  galleriaDkGreyPeri: galleriaDkGreyPeri,
  galleriaSandWhite: galleriaSandWhite,
  galleriaTurquoiseDkGold: galleriaTurquoiseDkGold,
  //meda
  medaDkGreyLtGreye: medaDkGreyLtGreye,
  medaIndBluePeri_c: medaIndBluePeri_c,
  medaOrangePwPink: medaOrangePwPink,
  medaWhiteSand: medaWhiteSand,
  //environment
  environment429C: environment429C,
  environment5025C: environment5025C,
  environment644C: environment644C,
  environmentCoolGrey1C: environmentCoolGrey1C,
  environmentWarmGrey3C: environmentWarmGrey3C,
  environmentWhite: environmentWhite,
  //fashion green
  //darsena
  darsenaIndBlueDkGrey:  darsenaIndBlueDkGrey,
  darsenaOrangeDkGrey: darsenaOrangeDkGrey,
  //necchi
  necchiOrangeIndBlue: necchiOrangeIndBlue,
  necchiTurquoiseBordeaux: necchiTurquoiseBordeaux,
  //orto botanico
  ortoBotanicoDkGreyLtGold: ortoBotanicoDkGreyLtGold,
  ortoBotanicoGrGreenIndBlue: ortoBotanicoGrGreenIndBlue,
  //parco acqua
  parcoAcquaPeriDkGold: parcoAcquaPeriDkGold,
  parcoAcquaPwPinkDkGold: parcoAcquaPwPinkDkGold,
  //roseto
  rosetoOrangeDkGrey: rosetoOrangeDkGrey,
  rosetoSandDkGrey: rosetoSandDkGrey,
  //san babila
  rosetoSanBabila: rosetoSanBabila,
  //sempione
  rosetoSempione: rosetoSempione,
  //jaquard orange
  //city life
  cityLifeBordeauxPrPinkBordeaux: cityLifeBordeauxPrPinkBordeaux,
  cityLifeDkGreyLtGreyDkGrey: cityLifeDkGreyLtGreyDkGrey,
  cityLifeIndBlueGrGreenIndBlue: cityLifeIndBlueGrGreenIndBlue,
  //galleria
  galleriaDkChocolateOrangeDkChocolate: galleriaDkChocolateOrangeDkChocolate,
  galleriaDkGreyPeriDkGrey: galleriaDkGreyPeriDkGrey,
  galleriaTurquoiseDkGoldDkGold: galleriaTurquoiseDkGoldDkGold,
  //meda
  medaDkGreyLtGrey_b: medaDkGreyLtGrey_b,
  medaIndBluePeri_b: medaIndBluePeri_b,
  medaOrangePrPink_b: medaOrangePrPink_b,
  //palestro
  palestroDkGreyBordeaux: palestroDkGreyBordeaux,
  palestroLtGreyDkChocolate: palestroLtGreyDkChocolate,
  palestroPeriOrange: palestroPeriOrange,
  //vela
  velaDkChocolateWhite: velaDkChocolateWhite,
  velaDkGoldWhite_b: velaDkGoldWhite_b,
  velaDkGreyWhite_c: velaDkGreyWhite_c,
  //velasca
  velascaBordeauxSand: velascaBordeauxSand,
  velascaDkChocolateOrange: velascaDkChocolateOrange,
  velascaDkGreyLtGrey: velascaDkGreyLtGrey,
  //jacquard blue
  //accademia
  accademiaBordeauxPwPink: accademiaBordeauxPwPink, 
  accademiaDkChocolateLtGrey: accademiaDkChocolateLtGrey, 
  accademiaDkGreyLtGrey: accademiaDkGreyLtGrey, 
  accademiaOrangeWhite_b: accademiaOrangeWhite_b, 
  //vela
  velaDkChocolate: velaDkChocolate, 
  velaDkGold: velaDkGold, 
  velaDkGrey: velaDkGrey, 
  velaWhite: velaWhite,
  //timeless blue
  //fontana
  fontanaBordeaux: fontanaBordeaux,
  fontanaDkGold: fontanaDkGold,
  fontanaDkGrey: fontanaDkGrey,
  fontanaIndBlue: fontanaIndBlue,
  fontanaTurquoise:  fontanaTurquoise,
  //naviglio
  naviglioBordeaux:  naviglioBordeaux,
  naviglioDkGold: naviglioDkGold,
  naviglioDkGrey: naviglioDkGrey,
  naviglioIndBlue: naviglioIndBlue,
  naviglioTurquoise: naviglioTurquoise,
  //piazza
  piazzaBlue: piazzaBlue,
  piazzaBordeaux: piazzaBordeaux,
  piazzaGold: piazzaGold,
  piazzaGrey: piazzaGrey,
  piazzaTurquoise: piazzaTurquoise,
  //timeless magenta
  //sforza
  sforzaBlack: sforzaBlack,
  sforzaBordeaux: sforzaBordeaux,
  sforzaDkChocolate: sforzaDkChocolate,
  sforzaDkGold: sforzaDkGold,
  sforzaDkGrey: sforzaDkGrey,
  sforzaGrGreen: sforzaGrGreen,
  sforzaIndBlue: sforzaIndBlue,
  sforzaIvory: sforzaIvory,
  sforzaLtGold: sforzaLtGold,
  sforzaLtGrey: sforzaLtGrey,
  sforzaNavy: sforzaNavy,
  sforzaOrange: sforzaOrange,
  sforzaPeri: sforzaPeri,
  sforzaPwPink: sforzaPwPink,
  sforzaSand: sforzaSand,
  sforzaTurquoise: sforzaTurquoise,
  sforzaViolet: sforzaViolet,
  sforzaWhite: sforzaWhite
};

export default iconsMap
